// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapBadge, BootstrapIcon } from '../../../../dsl/front'

import { ContentSneakPeakData } from '../../../_contracts'

/**
 * Tile labels component
 * Displays article labels including premium badge and custom labels
 */
@Component<TileLabels>({
  name: 'TileLabels',
  components: {
    BootstrapBadge,
    BootstrapIcon
  },
  template: `
    <ul v-if="shouldShow" class="tile__labels list-inline">
      <li v-if="article.paywall" class="tile__label">
        <BootstrapBadge>
          <BootstrapIcon name="premium" size="small" />
          premium
        </BootstrapBadge>
      </li>
      <template v-if="showArticleTags">
        <li v-for="(label, index) in labels" :key="label.name + index"
            class="tile__label">
          <BootstrapBadge :theme="label.color">
            {{ label.name }}
          </BootstrapBadge>
        </li>
      </template>
    </ul>
  `
})
export class TileLabels extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  public readonly article!: ContentSneakPeakData

  @Prop({
    type: Boolean,
    required: true
  })
  public readonly showArticleTags!: boolean

  /**
   * Determines if labels should be visible
   */
  public get shouldShow (): boolean {
    return (this.showArticleTags && this.hasLabels) || this.article.paywall || this.article.sponsored
  }

  /**
   * Gets article labels if available
   */
  public get labels () {
    if (!this.hasLabels) {
      return []
    }

    return this.article.properties.labels
  }

  /**
   * Determines whether there are any labels to be rendered
   */
  private get hasLabels (): boolean {
    return (
      this.article.properties.labels !== null &&
      Array.isArray(this.article.properties.labels) &&
      this.article.properties.labels.length > 0
    )
  }
}
